const constants = {
  SET_QUERY: "SET_QUERY"
}

export default constants;
